// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
export default noopTheme;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/getStylesCreator/noopTheme.js
// module id = 381
// module chunks = 0